export default "__VITE_ASSET__DTevb3MW__"